// extracted by mini-css-extract-plugin
export default {"mCard":"qF-z","image":"rF-z","imageNoBackground":"sF-z","imageHasCategory":"tF-z","fullWidth":"uF-z"};